import debugLog from "@/composables/debugLog";
import appConf from "@/config/config";

const getLocs = () => {
  let data;
  const loadLocs = async (urlIn, params) => {
    try {
      debugLog(urlIn);
      const jsonParams = JSON.stringify(params);
      debugLog(jsonParams);

      data = await fetch(urlIn, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: jsonParams,
      });

   
      let locs = await data.clone().json();
      debugLog(locs);
      if (locs.error) {
        alert(locs.message || "Error, laden Sie bitte die Seite neu, und versuchen Sie bitte nochmal.");
        debugLog(locs.info);
      } else {
          // LESS RESULTS FOR PDF
        return filterLocs(locs);
      }
    } catch (err) {
      console.log(err);
      if(appConf.debug){
        debugLog(data);
        let body = await data.text();
        debugLog(body);
      }
    }
  };

  return { loadLocs };
};

const filterLocs = (locs) => {
  let retAr = [];
  $.each(locs, function (i, docUp) {
    if (docUp.o == "Berlin") {
      retAr.push(docUp);
    }
  });
  return retAr;
};

export default getLocs;
